/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".m-tl[_ngcontent-%COMP%]{margin:14px 0 0 12px}.m-t14[_ngcontent-%COMP%]{margin-top:14px}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.btn-primary[_ngcontent-%COMP%]{background-color:#1f9fe4!important;border-color:#128dd0!important;padding:6px 32px}.btn-info[_ngcontent-%COMP%]{padding:6px 32px}input[type=date][_ngcontent-%COMP%]{border-radius:4px;padding:6px}"];
export { styles as styles };
